import React, { Component } from 'react';
import Aux from '../../../hoc/Aux';
import axios from '../../../axios-ns';

import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import * as messages from '../../../messages';
import Fab from '@material-ui/core/Fab';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Avatar from '@material-ui/core/Avatar';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarHalf';

class AvailableUpgrades extends Component {
    state = {
        upgrades: [],
        loading: true
    }

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/products/' + this.props.match.params.productCode + '/not-bought-upgrades', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ upgrades: response.data, loading: false });
                }).catch(err => {
                    this.setState({ ...this.state, loading: false });
                })
        }
    }

    render() {
        let content = null;

        if (this.state.upgrades) {
            if (this.state.loading) {
                content = <Spinner />
            } else if (this.state.upgrades.length == 0) {
                content = <p>{messages.YOU_HAVE_ALL_UPGRADES}</p>
            } else {
                content = this.state.upgrades.map(p => {
                    let price = <Fab color="secondary" style={{ position: 'absolute', margin: '20px' }}>
                        <h3>
                            {p.price} zł
                    </h3>
                    </Fab>;

                    let fill = +p.stars;
                    let border = 5 - +p.stars;
                    let stars = Array(fill).fill(1).map(e => <StarIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);
                    let borderStars = Array(border).fill(1).map(e => <StarBorderIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);

                    let str = p.available == '1' ? (<span style={{ color: 'orange' }}> {stars} {borderStars} ({p.votes})</span>) : <span>&nbsp;</span>;

                    let actions = p.available == '1' ? (<CardActions style={{ float: 'right' }}>
                        <Button size="small" color="primary" onClick={() => { window.open(p.landingPage, "_blank") }} style={{ float: 'right' }}>
                            {messages.MORE}
                        </Button>
                        <Button variant="contained" size="small" color="primary" component={Link} to={'/buy-product/' + p.code}>
                            {messages.BUY_NOW}
                        </Button>
                    </CardActions>) : <CardActions style={{ float: 'right' }}><b>{messages.SOON}</b></CardActions>;

                    return (
                        <Card key={p.name}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="Recipe" style={{ backgroundColor: p.color }}>
                                        {p.code}
                                    </Avatar>
                                }
                                title={p.name}
                            />
                            <CardActionArea>
                                {price}
                                <CardMedia
                                    component="img"
                                    style={{ border: '0px', padding: '0px', borderRadius: '0px', borderTop: '1px solid #eee', borderBottom: '1px solid #eee' }}
                                    image={p.thumbnail}
                                    title=""
                                />
                                <CardContent>
                                    {str}
                                    <Typography component="div">
                                        <p dangerouslySetInnerHTML={{ __html: p.description }}></p>
                                        {/* <b style={{ fontSize: '25px' }}><s>{Math.round(p.price * 1.30)} zł</s> {p.price} zł</b> */}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            {actions}
                        </Card>);
                });
            }
        }

        return <Aux>
            {content}
        </Aux>
    }
}


export default AvailableUpgrades; 